import { render, staticRenderFns } from "./Versions.vue?vue&type=template&id=a2451afa&"
import script from "./Versions.vue?vue&type=script&lang=js&"
export * from "./Versions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2451afa')) {
      api.createRecord('a2451afa', component.options)
    } else {
      api.reload('a2451afa', component.options)
    }
    module.hot.accept("./Versions.vue?vue&type=template&id=a2451afa&", function () {
      api.rerender('a2451afa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Quotations/Tabs/Versions.vue"
export default component.exports